module.exports = __webpack_public_path__ + "img/defaultProductIco.498249df.png";